ACC.registration = {

    initPageEvents: function ()
    {
       
    }
};

$(document).ready(function ()
{
    ACC.registration.initPageEvents();
});
